import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listBatteries } from '../Api'

export default generateApiAction({
  baseType: Types.BATTERIES.LIST,
  api: listBatteries,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/batteries/ListAction.js